import { OrganizationQueryParams } from '../../../interfaces/queryParams';
import { IMutationProps } from '../../../interfaces/ui';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { patchGraspLedLevel } from '../../graspManagement';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { IPatchObject } from '../../../interfaces/request';

export type usePatchGraspLedLevelBody = {
  patchData: IPatchObject[];
  id: string;
};

const usePatchGraspLedLevel = (
  params: OrganizationQueryParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (data: usePatchGraspLedLevelBody) => {
      await patchGraspLedLevel(params.organizationId, data.id, data.patchData);
    },
    resetOnResult: true,
    onSuccess: () => {
      displaySuccessNotification('OrganizationGrasps.updateSuccess');
      if (options.successFb) options.successFb();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'OrganizationGrasps.updateError'
      );
    },
  });
};

export default usePatchGraspLedLevel;
